<template>
    <tr v-on:click="showVps(domain, server.id)">
        <td class="vps-overview__table-cell"> <!-- v-on:click="showVps(domain, server.id)" -->
            {{ server.status }}
        </td>
        <td class="vps-overview__table-cell">
            <span>
                {{ server.display_name }}
            </span>
        </td>
        <td class="vps-overview__table-cell">
            <span>
                {{ server.offer.data.description }}
            </span>
        </td>
        <td class="vps-overview__table-cell | u-text-right">
            <div class="vps-overview__delete">
                <button class="vps-overview__delete-button" v-if="canDelete" @click="showDeleteModal($event)">
                    <img src="../assets/feather-icons/trash.svg" />
                </button>
            </div>
        </td>

        <confirmation-modal v-if="confirmationModalVisible && canDelete" v-on:removedserver="updateList($event, serverid)"
                            @close="closeModal" :server="server" :domain="domain" :subscriptions="servicesByDomain" />
    </tr>
</template>

<script>
import ConfirmationModal from "./ConfirmationModal.vue";
import serviceMixin from '../../../technical-management/src/mixins/service.js';

export default {
    components: {
        ConfirmationModal
    },
    mixins: [serviceMixin],
    props: {
        domain: {
            type: String,
            required: true
        },
        server: Object,
        updating: {
            type: Boolean,
            default: false
        },
        subscription: {
            type: Object,
            required: true
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            confirmationModalVisible: false,
            vpsDeleted: false
        };
    },
    computed: {
        /**
         * Checks if the subscription is active.
         *
         * @return {boolean}
         */
        canDelete() {
            return (this.server.status !== 'Rebooting' && this.server.status !== 'Starting' &&
                this.server.status !== 'Stopping' && this.server.status !== 'Deploying') &&
                this.subscription.administrative_status === 'active';
        },
    },
    methods: {
        /**
         * Show the modal if you delete a server
         */
        showDeleteModal(event) {
            event.preventDefault();
            event.stopPropagation();
            this.confirmationModalVisible = true;
        },

        /**
         * Close the modal.
         */
        closeModal() {
            this.confirmationModalVisible = false;
        },

        /**
         *
         */
        showVps(domain, serverid) {
            this.$router.push({ name: 'vpsDetails', params: { domain: domain, serverid: serverid } });
        },

        /*
         *
         */
        removeServerFromList(serverid) {
            this.$parent.removeServerFromList(serverid);
            this.vpsDeleted = true;
        }
    },
    watch: {
        server: {
            /**
             * Process the changed server from the store.
             *
             * @param {object} server
             */
            handler(server) {
                this.server = { ...server };
            },
            deep: true
        }
    }
};
</script>
